module.exports = __webpack_public_path__ + "static/media/happy8.4e803561.svg";